import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import styled from 'styled-components';
import { operationType } from "../../../../services/types";
import { updateNodeValue } from "../../../../services/method";
import { Textarea } from "../../../form/textarea";
import { TextInput } from "../../../form/textInput";
import { SettingsBlock, settingsDataType } from "../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../expanded";

type QueryProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function QueryDatabase({ id, data, setChildMinimize, setChildSettings }: QueryProps) {
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);

   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: e.target.value });
   }

   // ---
   const isWarning = !data.value?.connection_string;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ minWidth: '350px' }}
         ><Styled>
            <TextInput keyRef="connection_string" title="Connection" placeholder="connection_string" value={ data.value?.connection_string } handleChange={ handleChangeInput } />
            <Textarea
               keyRef="sql_query"
               value={ data.value?.sql_query } 
               placeholder="sql_query" 
               handleChange={ handleChangeInput } 
            />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}

// ---
const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

// ---
const Styled = styled.div`
   width: 350px;
   .textInput {
      margin-bottom: 10px;
      h4 {
         width: 125px;
      }
   }
`;